import React from 'react';

function NewsLetter() {
    return (
        <div className='bg-blue-300 w-full py-16 px-4'>
            <div className='max-w-[1250px] mx-auto md:grid grid-cols-3'>
                <div className='lg:col-span-2 col-span-1 my-4'>
                    <h1 className='md:text-[40px] text-[20px] font-bold sm:text-3xl text-2xl py-2'>Want to learn latest I.T skills?</h1>
                    <p>Sign up to our newsletter and stay up to date.</p>
                </div>
                <div className='my-4'>
                    <input className='w-full md:w-auto mr-2 md:p-2 text-slate-600 border border-gray-400 p-4 rounded outline-none' type="email" placeholder='Enter Email' />
                    <button className='w-full md:w-auto bg-black text-white p-2 px-5 rounded my-2'>Notify Me</button>
                    <p className='text-center md:text-justify text-white font-semibold'>
                        We care bout the protection of your data. Read our{' '}
                        <span className='text-black'>Privacy Policy.</span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default NewsLetter